const selectors = {
  accountPages: '[data-account-pages]',
  resetPassword : '[data-recover-link]',
  hideResetPass : '[data-hideResetPass]',
  resetPasswordForm : '[data-recover-password-form]',
  loginForm : '[data-login-form] form'
};

class accountPages {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupEventListeners();

    const windowURL = window.location.href;
    const showRecoverForm = windowURL.indexOf('#recover');
    if(showRecoverForm >= 0){
      this.elements.showResetPassword.dispatchEvent(new Event('click'));
    }
    this.elements.loginForm.addEventListener('submit', (e)=>{
      e.preventDefault();
      this._generateCustomerToken(this.elements.loginForm);
    });
  }

  _getElements() {
    const container = document.querySelector(selectors.accountPages);
    return container ? {
      container,
      showResetPassword: document.querySelector(selectors.resetPassword),
      hideResetPass: document.querySelector(selectors.hideResetPass),
      resetPasswordForm: document.querySelector(selectors.resetPasswordForm),
      loginForm: document.querySelector(selectors.loginForm)
    } : {};
  }

  _setupEventListeners() {
      this.elements.showResetPassword.addEventListener('click', this._handleResetPassword.bind(this));
      this.elements.hideResetPass.addEventListener('click', this._handleResetPassword.bind(this));
  }

  _handleResetPassword(event){
      event.preventDefault();
      const _this = event.currentTarget;
      if(_this.classList.contains('hide-resetform')){
        this.elements.loginForm.style.display = 'block';
        this.elements.resetPasswordForm.style.display = 'none';
        if(window.location.href.indexOf("#recover") > -1) {
          window.history.replaceState({ }, '', location.href.replace("#recover", ""));
        }
      }else{
          this.elements.loginForm.style.display = 'none';
          this.elements.resetPasswordForm.style.display = 'block';
      }
  }
  _generateCustomerToken(loginFormElement){
      var email = document.getElementById('customerEmail').value;
      var password = document.getElementById('customerPassword').value;
  
      const query = `mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
        customerAccessTokenCreate(input: $input) {
            customerUserErrors {
              code
              field
              message
            }
            customerAccessToken {
              accessToken
              expiresAt
            }
        }
      }`;
    
      // Set the body
      var requestBody = JSON.stringify({
        query: query,
        variables: {
          input: {
            email: email,
            password: password
          }
        }
      });
  
      fetch('/api/2023-04/graphql.json', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              "Access-Control-Origin": "*",
              "Access-Control-Allow-Origin": "*",
              'X-Shopify-Storefront-Access-Token': "97ba770f25c3e41f2fdae9c53feca38d"
          },
          body: requestBody,
      })
      .then((response) => response.json())
      .then((data) => {
        const resultData = data.data.customerAccessTokenCreate;
        if(resultData.customerAccessToken == null){
          loginFormElement.submit();
        }else{
          const customerAccessToken = resultData.customerAccessToken.accessToken;
          let expiryCookie = (24*60*60)*7;
          document.cookie = `customerAccessToken=${customerAccessToken}; max-age=${expiryCookie}; path=/account`; 
          loginFormElement.submit();
        }
      });
  }
}

typeof accountPages !== 'undefined' && new accountPages();